<template>
  <div>
    
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10 ">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <form
            ref="addCourseRef"
            class="rounded-2xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto bg-white"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourse"
          >
            <div class="flex items-center justify-between flex-wrap">
              <h1
                class="py-2 text-xl text-center font-bold text-textblues w-full md:w-auto"
              >
                Add New Course
              </h1>

              <div @click="closeEmit"
                class="bg-blues text-white rounded-lg text-sm font-semibold px-3 py-1 cursor-pointer"
                >Close</div
              >
            </div>

            <div class="py-10 flex flex-col gap-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <!-- <div class="flex flex-col gap-3">
                  <label for="batch_year" class="text-sm"
                    >Batch Year <span class="text-red-400">*</span></label
                  >
                  <select
                    id="batch_year"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Batch</option>
                    <option
                      v-for="batch_year in batch_years"
                      :key="batch_year.year"
                      :value="batch_year.year"
                    >
                      {{ batch_year.year }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span> 
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                    </label
                  >
                  <select
                    id="program_name"
                    required
                    @change="getProgramsFilter()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Programs</option>
                    <option
                      v-for="program in programs"
                      :key="program.id"
                      :value="program.name"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="department" class="text-sm flex gap-2"
                    >Departments <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="isDepartment = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="department"
                    @change="getInstructorListByFilter()"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                  <option value="" selected disabled>Select Department</option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.name"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="semester" class="text-sm"
                    >Semester<span class="text-red-400">*</span></label
                  >
                  <select
                    id="semester"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                   
                    <option value="" selected disabled>Select Semester</option>
                    <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                    <option value="V">V</option>
                    <option value="VI">VI</option>
                   
                  </select>
                </div> -->
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5"> 
                
                <!-- <div class="flex flex-col gap-3">
                  <label class="text-sm">Section</label>
                  <select
                    id="section"
                    placeholder="A, B, C.."
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="" disabled>Select Section</option>
                    <option
                      v-for="section in sections"
                      :key="section.id"
                      :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div> -->

                <!-- Section -->
                <div class="flex flex-col gap-3">
                  <label class="text-sm flex gap-2">Section <span class="text-red-400">*</span>
                    <font-awesome-icon
                      @click="isSection = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label> 
                   <!-- <font-awesome-icon
                      @click="isSection = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800 hidden"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    /></label> -->
                  <select
                    id="section"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="" disabled>Select Section</option>
                    <option
                      v-for="section in sections"
                      :key="section.id"
                      :value="section.id"
                    >
                      {{ section.name }}
                    </option>
                  </select>
                </div>

                <!-- <div class="flex flex-col gap-3">
                  <label for="section" class="text-sm"
                    >Section <span class="text-red-400">*</span></label
                  >
                  <input
                    id="section"
                    type="text"
                    placeholder="A, B, C.."
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div> -->

                <!-- <div class="flex flex-col gap-3">
                  <label for="faculty" class="text-sm"
                    >Select Faculty <span class="text-red-400">*</span></label
                  >
                  
                  <select
                    id="instructor_id"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Faculty</option>
                    <option
                      v-for="instructor_list in instructor_lists"
                      :key="instructor_list.id"
                      :value="instructor_list.id"
                    >
                      {{ instructor_list.user.email }}
                    </option>
                  </select>
                </div> -->

                <div class="flex flex-col gap-3">
                  <label class="text-sm">Select Faculty </label>
                  <select
                    id="instructor_id"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3"
                  >
                    <option value="" disabled>Select Faculty</option>
                    <option
                      v-for="instructor in instructor_lists"
                      :key="instructor.id"
                      :value="instructor.id"
                    >
                      {{ instructor.user.email }}
                    </option>
                  </select>
                </div>

              </div>

              <!-- New Fields -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="credits" class="text-sm"
                    >Credits</label
                  >
                  <input
                    id="credits"
                    type="number"
                    
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="exam_duration" class="text-sm flex gap-2"
                    >Exam Duration 
                  </label>
                  <input
                    id="exam_duration"
                    type="number"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="cie" class="text-sm"
                    >CIE</label
                  >
                  <input
                    id="cie"
                    type="number"
                    @input="addNumber"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="see" class="text-sm flex gap-2"
                    >SEE 
                  </label>
                  <input
                    id="see"
                    type="number"
                    @input="addNumber"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="total" class="text-sm flex gap-2"
                    >Total
                  </label>
                  <input
                    id="total"
                    type="number"
                    disabled
                    
                    class="bg-[#eaeaeb] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <!-- <div class="flex flex-col gap-3">
                  <label for="total_contact_hours" class="text-sm flex gap-2"
                    >Total Contact Hours 
                  </label>
                  <input
                    id="total_contact_hours"
                    type="number"
                    min="1" 
                    max="10"
                    @input="validateNumber('total_contact_hours')"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div> -->
                 <div class="flex flex-col gap-3">
                  <label for="total_contact_hours" class="text-sm flex gap-2 items-center"
                    >Total Contact Hours   <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                        HH:MM format
                        </div>
                      </div>
                  </label>
                  <input
                    id="total_contact_hours"
                    type="text"
                   maxlength="4"
                     @blur="convertTimeOnBlur"
                     placeholder="HH:MM"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
                <div class="flex flex-col gap-3">
                  <label for="no_of_contact_hours" class="text-sm flex gap-2"
                    >No of Contact Hours 
                  </label>
                  <input
                    id="no_of_contact_hours"
                    type="number"
                    min="1" 
                    max="10"
                    @input="validateNumber('no_of_contact_hours')"
                    
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="tutor_hours" class="text-sm flex gap-2"
                    >Tutor Hours 
                  </label>
                  <input
                    id="tutor_hours"
                    type="text"
                    @input="validateNumber('tutor_hours')"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="practical_hours" class="text-sm flex gap-2"
                    >Practical Hours 
                  </label>
                  <input
                    id="practical_hours"
                    type="text"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3">
                  <label for="ltp" class="text-sm flex gap-2"
                    >LTP 
                  </label>
                  <input
                    id="ltp"
                    type="text"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

              </div>

              <div class="grid grid-cols-1">
                <div class="flex flex-col gap-3">
                  <label for="title" class="text-sm"
                    >Title <span class="text-red-400">*</span></label
                  >
                  <input
                    id="title"
                    type="text"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="course_code" class="text-sm flex gap-1 items-center"
                    >Course Code <span class="text-red-400">*</span>
                    <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Unique course code
                        </div>
                      </div>
                     </label
                  >
                  <input
                    id="course_code"
                    type="text"
                    maxlength="10"
                   required
                   @input="validateCourseCode"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                  <p v-if="errorMessage" class="text-red-500 text-sm mt-1">{{ errorMessage }}</p>
                  <p v-if="errorgreenMessage" class="text-green-500 text-sm mt-1">{{ errorgreenMessage }}</p>
                </div>

                <div class="flex flex-col gap-3">
                  <label for="category" class="text-sm flex gap-2"
                    >Course Type 
                    <font-awesome-icon
                      @click="isCourseTypePopup = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="course_type"
                   
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>
                      Select Course Type
                    </option>
                    <option
                      v-for="type in courseTypeList"
                      :key="type.id"
                      :value="type.id"
                    >
                      {{ type.title }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex flex-col gap-3">
                <label for="short-desc" class="text-sm"
                  >Course objective is to <span class="text-red-400">*</span></label
                >
                <textarea
                  id="short-desc"
                  required
                  maxlength="1000"
                  class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                ></textarea>
              </div>

              <div class="flex flex-col gap-3">
                <label for="description" class="text-sm"
                  >Description <span class="text-red-400">*</span></label
                >
                <QuillEditor
                  style="height: 300px"
                  theme="snow"
                  class="border rounded-2xl"
                  toolbar="full"
                  :content="description"
                  contentType="html"
                />
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="outcome" class="text-sm">Outcome </label>
                  <textarea
                    id="outcome"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="requirement" class="text-sm"
                    >Requirements (if any)</label
                  >
                  <textarea
                    id="requirement"
                    maxlength="1000"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  ></textarea>
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="language" class="text-sm flex gap-2"
                    >Language

                    <font-awesome-icon
                      @click="addLanguage = true"
                      class="text-base text-green-500 self-end mt-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <!-- <input
                    id="language"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  /> -->
                  <select
                    id="languages"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="lang in languageList"
                      :key="lang.id"
                      :value="lang.id"
                    >
                      {{ lang.title }}
                    </option>
                  </select>
                </div>

                <div class="flex flex-col gap-3 lg:gap-0">
                  <label for="video_url" class="text-sm flex gap-1 items-center">Upload Video 
                     <!-- <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                        Only files below 500MB can be uploaded.
                        </div>
                      </div> -->
                      </label> 

                  <div class="w-full mt-2">
                    <form enctype="multipart/form-data" class="flex flex-col gap-2 w-full" method="POST"
                      @submit.prevent="videoUploadURL('fileuploadvideo', 'uploaded_files_video')">

                      <label class="font-bold text-sm">Select video file to upload.</label>

                      <div class="flex flex-row gap-2 w-full">
                        
                        <input type="file" class="bg-gray-100 rounded-lg p-3 border-none outline-none" id="fileuploadvideo"
                          accept="video/*" required />
                          <input type="submit" value="Upload" id="submit"
                          class="text-white bg-blues rounded-lg text-sm font-bold px-4 py-2 cursor-pointer" />
                      </div>
                      <!-- <div class="flex justify-end">
                       
                      </div> -->
                    </form>
                    <div id="uploaded_files_video" class="mt-2"></div>
                  </div>
                      <p class=" pl-[100px] w-[50px]">(or)</p>
                      <p class="text-black text-xs" v-if="isValidUrlBool.video_url == false">url.</p>
                  <p class="text-green-800 text-xs" v-if="isValidUrlBool.video_url  == true">URL valid.</p>
                  <input
                    id="video_url"
                    @change="isValidUrl('video_url')"
                    @input="isValidUrl('video_url')"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />

                 

                </div>
                <!-- <div class="flex flex-col gap-3">
                  <label for="level" class="text-sm">Level</label>
                  <select
                    id="level"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option
                      v-for="level in ['beginner', 'intermediate', 'advanced']"
                      :key="level"
                      :value="level"
                    >
                      {{ level }}
                    </option>
                  </select>
                </div> -->
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div class="flex flex-col gap-3">
                  <label for="thumbnail" class="text-sm"
                    >Thumbnail <span class="text-red-400">*</span></label
                  >
                  <input
                    id="thumbnail"
                    type="file"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />
                </div>

                <div class="flex flex-col gap-3 lg:gap-0">
                  <label for="pdf_urls" class="text-sm "
                    >Upload PDF</label
                  >

                  <div class="w-full mt-2">
                    <form enctype="multipart/form-data" class="flex flex-col gap-2 w-full" method="POST"
                      @submit.prevent="pdfUploadURL('fileuploadpdf', 'uploaded_files_pdf')">

                      <label class="font-bold text-sm">Select pdf file to upload.</label>

                      <div class="flex flex-row gap-2 w-full">
                        
                        <input type="file" class="bg-gray-100 rounded-lg p-3 border-none outline-none" accept="application/pdf" id="fileuploadpdf"
                          required />
                          <input type="submit" value="Upload" id="submit"
                          class="text-white bg-blues rounded-lg text-sm font-bold px-4 py-2 cursor-pointer" />
                      </div>
                      
                    </form>
                    <div id="uploaded_files_pdf" class="mt-2"></div>
                  </div>

                  <p class=" pl-[100px] w-[50px]">(or)</p>
                  <p class="text-black text-xs" v-if="isValidUrlBool.pdf_urls == false"> url.</p>
                  <p class="text-green-800 text-xs" v-if="isValidUrlBool.pdf_urls == true">URL valid.</p>
                  <input
                    @input="isValidUrl('pdf_urls')"
                    id="pdf_urls"
                    type="text"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  />

                  <!-- {{ isValidUrl }} -->
                  

                </div>

                <div class="flex mt-6 items-center gap-2">
                  <input type="checkbox" id="Published" />
                  <label for="Published" class="text-sm">Published</label>
                </div>
              </div>
              <!-- <div class="flex justify-between">
                <router-link :to="{ name: 'InstructorHome' }"
                  class=" bg-blues text-white rounded-lg text-lg font-semibold px-6 py-1.5">Back</router-link>
                <button type="submit" class="text-white bg-blues rounded-lg text-lg px-8 py-1.5">
                  Save
                </button>
              </div> -->
              <div class="flex gap-3 flex-wrap">
                <button
                  type="submit"
                  class="text-greens border border-greens rounded-lg text-lg font-semibold px-6 py-1.5"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="is_CategoryPopup"
      @click.self="is_CategoryPopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="is_CategoryPopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Category</h4>
        <form class="w-11/12 mx-auto pb-10" @submit.prevent="categoryAdd">
          <label for="title">
            Title
            <span class="text-red-400">*</span>
          </label>
          <input
            id="title"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Category
          </button>
        </form>
      </div>
    </div>


    <div
      v-if="isSection"
      @click.self="isSection = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isSection = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">Add Section</h4>
        <form class="w-11/12 mx-auto pb-10" ref="addSectionRef" @submit.prevent="sectionAdd">
          <label for="title">
            Name
            <span class="text-red-400">*</span>
          </label>
          <input
            id="name"
            type="text"
            required
            class="border border-gray-300 rounded-md text-sm w-full p-2"
          />
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Section
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="isDepartment"
      @click.self="isDepartment = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isDepartment = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Department
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-4" ref="addDepartment" @submit.prevent="AddDepartment">

          <div class="flex flex-col gap-1"> 
              <label for="name">
                Program
                <span class="text-red-400">*</span>
              </label>
              <select
                id="program_name"
                required
                class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
              >
                <option
                  v-for="program in programs"
                  :key="program.id"
                  :value="program.id"
                >
                  {{ program.name }}
                </option>
              </select>
            </div>
            

            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="name"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          

          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Department
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="isPrograms"
      @click.self="isPrograms = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isPrograms = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Programs
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-2" ref="addProgramsRef" @submit.prevent="AddPrograms">  

            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="name"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          

          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Program
          </button>
        </form>
      </div>
    </div>

    <div
      v-if="isCourseTypePopup"
      @click.self="isCourseTypePopup = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="isCourseTypePopup = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Course Type
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-2" ref="addCourseTyperRef" @submit.prevent="addCourseType">  
            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="title"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Course Type
          </button>
        </form>
      </div>
    </div>


    <div
      v-if="addLanguage"
      @click.self="addLanguage = false"
      class="fixed w-[100%] h-[100%] bg-gray-500 bg-opacity-50 left-0 right-0 top-0 bottom-0 flex items-center justify-center"
      style="z-index: 5001"
    >
      <div
        class="w-5/6 lg:w-2/3 2xl:w-1/3 bg-white rounded-lg flex flex-col justify-center py-4 relative"
      >
        <div
          @click="addLanguage = false"
          class="absolute right-4 top-4 cursor-pointer z-50"
        >
          <div class="mb-1 rounded-lg flex cursor-pointer">
            <img class="h-5 w-5 md:h-8 md:w-8" src="@/assets/closebutton.svg" />
          </div>
        </div>

        <h4 class="text-gray-700 text-center mt-10 font-bold">
          Add Language
        </h4>
        <form class="w-11/12 mx-auto pb-10 flex flex-col gap-2" ref="addLangRef" @submit.prevent="addLanguagePost">  
            <div class="flex flex-col gap-1"> 
              <label for="name">
                Name
                <span class="text-red-400">*</span>
              </label>
              <input
                id="title"
                type="text"
                required
                class="border border-gray-300 rounded-md text-sm w-full p-2"
              />
            </div>
          <button
            type="submit"
            class="bg-blues text-white mt-4 px-3 py-2 font-bold rounded-lg text-xs"
          >
            Add Language
          </button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>


class FileUpload1 {
  constructor(input,bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext; 
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">
       
                         <p class="filename1"></p>
                        <small class="textbox1"></small>
                        <div class="progressbar1">
                            <div class="progress1" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename1`).text(this.file.name);
    $(`.textbox1`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress1`).css("width", percent + "%");
            $(`.progress1`).text(percent + "%");
          }
        });
        return xhr;
      },

      url:`${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox1`).text(res.data);
          $(`#${append_id}`).val(
          `${process.env.VUE_APP_API}/media/` + res.existingPath
          ).trigger('input');
          self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}

class FileUpload {
  constructor(input,bar_url, vueContext) {
    this.bar_url = bar_url;
    this.input = input;
    this.max_length = 1024 * 1024 * 1024 * 100;
    this.vue = vueContext; 
  }

  create_progress_bar() {
    var progress = `<div class="file-icon">
                        <i class="fa fa-file-o" aria-hidden="true"></i>
                    </div>
                    <div class="file-details">
       
                         <p class="filename"></p>
                        <small class="textbox"></small>
                        <div class="progressbar">
                            <div class="progress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">
                            </div>
                        </div>
                    </div>`;
    document.getElementById(this.bar_url).innerHTML = progress;
  }

  upload(append_id) {
    this.create_progress_bar();
    this.initFileUpload(append_id);
  }

  initFileUpload(append_id) {
    this.file = this.input.files[0];
    this.upload_file(0, null, append_id);
  }

  //upload file
  upload_file(start, model_id, append_id) {
    var end;
    var self = this;
    var existingPath = model_id;
    var formData = new FormData();
    var nextChunk = start + this.max_length + 1;
    var currentChunk = this.file.slice(start, nextChunk);
    var uploadedChunk = start + currentChunk.size;
    if (uploadedChunk >= this.file.size) {
      end = 1;
    } else {
      end = 0;
    }

    formData.append("title", "title");

    formData.append("file", currentChunk);
    formData.append("filename", this.file.name);
    $(`.filename`).text(this.file.name);
    $(`.textbox`).text("Uploading file");
    formData.append("end", end);
    formData.append("existingPath", existingPath);
    formData.append("nextSlice", nextChunk);

    $.ajax({
      xhr: function () {
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", function (e) {
          if (e.lengthComputable) {
            if (self.file.size < self.max_length) {
              var percent = Math.round((e.loaded / e.total) * 100);
            } else {
              var percent = Math.round((uploadedChunk / self.file.size) * 100);
            }
            $(`.progress`).css("width", percent + "%");
            $(`.progress`).text(percent + "%");
          }
        });
        return xhr;
      },

      url:`${process.env.VUE_APP_API}/video-uploader/`,
      type: "POST",
      dataType: "json",
      cache: false,
      processData: false,
      contentType: false,
      data: formData,
      error: function (xhr) {
        alert(xhr.statusText);
      },
      success: function (res) {
        if (nextChunk < self.file.size) {
          // upload file in chunks
          existingPath = res.existingPath;
          self.upload_file(nextChunk, existingPath);
        } else {
          // upload complete
          $(`.textbox`).text(res.data);
          $(`#${append_id}`).val(
          `${process.env.VUE_APP_API}/media/` + res.existingPath
          ).trigger('input');
          self.vue.isValidUrl(append_id);
        }
      },
    });
  }
}


import axios from "axios";
import { mapGetters } from "vuex";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
   
    QuillEditor,
    FlashMessage,
  },

  props: ["batchYear", "departmentName", "programName", "semesterName"],

  data() {
    return {
      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      batch_years: [],
      programs: [],
      departments: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists:[],
      courseTypeList: [],
      isCourseTypePopup: false,
      addLanguage: false,
      languageList: [], 
      sections: [],
      isValidUrlBool: {
        video_url: false,
        pdf_urls: false,
      },
      isSection: false,
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    
    
    // this.getDepartments();
    this.getPrograms();
    this.getCourseTypeList();
    this.getLanguages();
    this.sectionsGet();
    this.getInstructorListByFilter();

    axios
      .get(
        `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        this.batch_years = res.data.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  mounted(){
    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js";
    script.onload = () => {
      console.log("jQuery loaded");
      this.initJQuery();
    };
    document.head.appendChild(script);
  },

  methods: {
      convertTimeOnBlur() {
  const el = document.getElementById('total_contact_hours');
  if (!el) return;

  const raw = el.value.trim().replace(/\D/g, '');

  let hours = '00';
  let minutes = '00';

  if (raw.length === 1) {
    hours = `0${raw}`;
  } else if (raw.length === 2) {
    hours = raw;
  } else if (raw.length === 3) {
    hours = raw.slice(0, 2);
    minutes = `${raw[2]}0`;
  } else if (raw.length === 4) {
    hours = raw.slice(0, 2);
    minutes = raw.slice(2, 4);
  } else {
    
    el.value = '';
    return;
  }

  el.value = `${hours}:${minutes}`;
},

    sectionAdd(){
      axios
        .post(
          `${process.env.VUE_APP_API}/section-create/?Key=${this.userInfo.token_key}`,
          {name: document.getElementById("name").value }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Section Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.sectionsGet();
              this.isSection = false;
              this.$refs.addSectionRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    initJQuery() {
      $(document).ready(() => {
        console.log("jQuery is ready in this component");
      });
    },

    videoUploadURL(id, bar_url) {
      var uploader = new FileUpload(document.querySelector(`#${id}`), bar_url, this);
      console.log(document.querySelector(`#${id}`));
      uploader.upload("video_url");
    },

    pdfUploadURL(id, bar_url) {
      var uploader = new FileUpload1(document.querySelector(`#${id}`), bar_url, this);
      console.log(document.querySelector(`#${id}`));
      uploader.upload("pdf_urls");
    },

    isValidUrl(id) {
      // let id = document.getElementById(id).value;
      try {
        new URL(document.getElementById(id).value);
        this.isValidUrlBool[id] = true;
        // return true;
      } catch (err) {
        this.isValidUrlBool[id] = false;
        // return false;1
      }
    }, 

    validateNumber(id) {
      let number = document.getElementById(id).value;
      if (number > 99) {
        document.getElementById(id).value = 99;
      } 
      // else if (number < 1) {
      //   document.getElementById(id).value = 1;
      // }
    },

    addNumber(){
      document.getElementById("total").value = parseInt(document.getElementById("cie").value) + parseInt(document.getElementById("see").value);
    },

    closeEmit(){
      this.$emit('close-Emit');
    },  

    sectionsGet() {
      axios
        .get(
          `${process.env.VUE_APP_API}/section-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.sections = res.data.data;
        });
    },

    getLanguages(){
      axios
        .get(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.languageList = res.data.data;
        });
    },

    addLanguagePost(el){
      
      let bodyVal = {
        title: el.target.elements.title.value
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/language/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Language Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.addLanguage = false;
              this.getLanguages();
              this.$refs.addLangRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    addCourseType(el){
      
      let bodyVal = {
        title: el.target.elements.title.value
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Course Type Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isCourseTypePopup = false;
              this.getCourseTypeList();
              this.$refs.addCourseTyperRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getCourseTypeList(){
      axios
        .get(
          `${process.env.VUE_APP_API}/course_type/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.courseTypeList = res.data.data;
        });
    },

    getInstructorListByFilter(){
      
      // let department_name = document.getElementById("department").value;

      axios
      .get(
        `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        console.log(res);
        this.instructor_lists = res.data.products;
      });
    },

    getProgramsFilter(){
      let program_name = document.getElementById("program_name").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__id=${program_name}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });

    },

    AddPrograms(el){
      
      let bodyVal = {
        name: el.target.elements.name.value
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isPrograms = false;
              this.getPrograms();
              this.$refs.addProgramsRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    getPrograms(){
      axios
        .get(`${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`)
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      let bodyVal = {
        name: el.target.elements.name.value,
        program: el.target.elements.program_name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Department Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isDepartment = false;
              this.getDepartments();
              this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    categoryAdd(el) {
      let bodyVal = {
        title: el.target.elements.title.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/categorynew/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          console.log(response.data.message);
          if (response.data.message == "your Category added successfully") {
            this.messages = {
              text: "Category Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.is_CategoryPopup = false;
              this.categoryget();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },

    async createCourse(e) {
      let token = this.userInfo.token_key;

      this.description = document.querySelector(".ql-editor").innerHTML;
      console.log(this.description);

      // let urls = `${process.env.VUE_APP_API}/coursenew/?Key=${token}`;

      let urls = `${process.env.VUE_APP_API}/course-doc-create/?Key=${token}`

      let HeaderVal = new FormData();
      if (e.target.elements.thumbnail.files.length > 0) {
        var thumbnailVal = e.target.elements.thumbnail.files[0];
        HeaderVal.append("thumbnail", thumbnailVal);
      }

      HeaderVal.append("course_type", e.target.elements.course_type.value);

      HeaderVal.append("batch", Number(this.batchYear));
      HeaderVal.append("program", Number(this.programName));
      HeaderVal.append("department", Number(this.departmentName));
      HeaderVal.append("semester", Number(this.semesterName));
      HeaderVal.append("class_section", Number(e.target.elements.section.value));
      HeaderVal.append("instructor", Number(e.target.elements.instructor_id.value));

      HeaderVal.append("tutor_hours", e.target.elements.tutor_hours.value);
      HeaderVal.append("practical_hours", e.target.elements.practical_hours.value);
      HeaderVal.append("ltp", e.target.elements.ltp.value);

      HeaderVal.append("credits", e.target.elements.credits.value);
      HeaderVal.append("exam_duration", e.target.elements.exam_duration.value);
      HeaderVal.append("total", e.target.elements.total.value);
      HeaderVal.append("cie", e.target.elements.cie.value);
      HeaderVal.append("see", e.target.elements.see.value);
      HeaderVal.append("total_contact_hours", e.target.elements.total_contact_hours.value);
      HeaderVal.append("no_of_contact_hours", e.target.elements.no_of_contact_hours.value);

  
      HeaderVal.append("title", e.target.elements.title.value);
      // HeaderVal.append("category", parseInt(e.target.elements.category.value));
      HeaderVal.append(
        "short_description",
        e.target.elements["short-desc"].value
      );

      HeaderVal.append("description", this.description);
      HeaderVal.append("outcome", e.target.elements.outcome.value);
      HeaderVal.append("requirements", e.target.elements.requirement.value);
      HeaderVal.append("languages", e.target.elements.languages.value);
      HeaderVal.append("price", 0);
      HeaderVal.append("course_free", true);
      HeaderVal.append("level", "0");
      HeaderVal.append("video_url", e.target.elements.video_url.value);
      HeaderVal.append("is_published", e.target.elements.Published.checked);
      HeaderVal.append("organization_id", this.userInfo.organizes_id);
      HeaderVal.append("course_code", e.target.elements.course_code.value);
      HeaderVal.append("pdf_urls", e.target.elements.pdf_urls.value);


      await axios
        .post(urls, HeaderVal, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.addCourseRef.reset();
              this.closeEmit();
              // this.$router.push({
              //   name: "InstructorCourses",
              // });
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        }).catch((err)=>{
          if(err){
            if(err.response.data.non_field_errors){
              this.messages = {
                text: err.response.data.non_field_errors[0],
                type: "error",
              };
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "null",
                };
              }, 2000);
            }
            // console.log(err.response.data.non_field_errors);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
